<template>
    <img src="~/assets/icon/icon-sbp.svg" style="width: 26px;padding-left: 3px;" alt="" />
</template>
